import React from 'react';
import './Pagination.css';
import { buildPaginationPages } from '../utils/pagination';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  maxVisiblePages = 5 
}) => {
  const visiblePages = buildPaginationPages({
    currentPage,
    totalPages,
    maxVisiblePages,
  });

  const handleFirstPage = () => {
    if (currentPage > 1) {
      onPageChange(1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      onPageChange(totalPages);
    }
  };

  const handlePageClick = (page) => {
    if (page !== '...' && page !== currentPage) {
      onPageChange(page);
    }
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination-container">
      {/* Кнопки навигации слева */}
      <button 
        className="pagination-nav-btn"
        onClick={handleFirstPage}
        disabled={currentPage === 1}
        aria-label="Первая страница"
      >
        <span className="pagination-icon">⏮</span>
      </button>
      
      <button 
        className="pagination-nav-btn"
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
        aria-label="Предыдущая страница"
      >
        <span className="pagination-icon">◀</span>
      </button>

      {/* Номера страниц */}
      <div className="pagination-pages">
        {visiblePages.map((page, index) => (
          <React.Fragment key={index}>
            {page === '...' ? (
              <span className="pagination-ellipsis">...</span>
            ) : (
              <button
                className={`pagination-page-btn ${
                  page === currentPage ? 'pagination-page-btn--active' : ''
                }`}
                onClick={() => handlePageClick(page)}
                aria-label={`Страница ${page}`}
                aria-current={page === currentPage ? 'page' : undefined}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Кнопки навигации справа */}
      <button 
        className="pagination-nav-btn"
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        aria-label="Следующая страница"
      >
        <span className="pagination-icon">▶</span>
      </button>
      
      <button 
        className="pagination-nav-btn"
        onClick={handleLastPage}
        disabled={currentPage === totalPages}
        aria-label="Последняя страница"
      >
        <span className="pagination-icon">⏭</span>
      </button>
    </div>
  );
};

export default Pagination;
